import { lazy, Suspense } from "react";
import Hero from "../components/hero";
import Footer from "../components/footer";

const Book = lazy(() => import("../components/About-the-book"));
const MeetHost = lazy(() => import("../components/meet-host"));
const Compromise = lazy(() => import("../components/no-compromise"));
const AboutShow = lazy(() => import("../components/about-the-show"));
const Listen = lazy(() => import("../components/listen"));
const Garden = lazy(() => import("../components/garden-2"));
const Make = lazy(() => import("../components/make"));
const Switch = lazy(() => import("../components/Making-the-switch"));
const Podcast = lazy(() => import("../components/podcasts"));

const Home = () => {
  return (
    <>
      <Hero />
      <Suspense fallback={null}>
        <Book />
        <Podcast />
        <Switch />
        <MeetHost />
        <Compromise />
        <AboutShow />
        <Listen />
        <Garden />
        <Make />
        <Footer />
      </Suspense>
    </>
  );
};

export default Home;
